// extracted by css-extract-rspack-plugin
export default {"root":"e1e17k","core-symbol":"xbRYXj","coreSymbol":"xbRYXj"};